import { ref, shallowRef } from 'vue';

const useComposable = (emits) => {
  const refs = {
    year: ref(-1),
    months: shallowRef([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    realityDate: ref()
    //* 真实日期
  };
  const variable = {
    disabled: void 0
  };
  const methods = {
    //* 切换时间
    changeDate: (date) => emits("update", "month", date),
    //* 选择月份
    changeMonth: (month) => {
      if (!(variable.disabled && variable.disabled(/* @__PURE__ */ new Date(`${refs.year.value}-${month + 1}`)))) {
        emits("change", { month, year: refs.year.value });
      }
    }
  };
  const disposes = {
    //* 初始化函数
    init: (data, disabled) => {
      refs.year.value = data.date.getFullYear();
      refs.realityDate.value = data.realityDate;
      variable.disabled = disabled;
    },
    //* 获取当前月份的className
    receiveDayClassName: (month) => {
      var _a, _b;
      return {
        "ui-active": ((_a = refs.realityDate.value) == null ? void 0 : _a.getFullYear()) == refs.year.value && ((_b = refs.realityDate.value) == null ? void 0 : _b.getMonth()) == month,
        "ui-disabled-status": variable.disabled && variable.disabled(/* @__PURE__ */ new Date(`${refs.year.value}-${month + 1}`))
      };
    }
  };
  return { refs, methods, disposes };
};

export { useComposable };
//# sourceMappingURL=composable.mjs.map
